<template>
  <div class="dhmap-wrapper">
    <map-locator :param="param" mode='h5'></map-locator>
  </div>
</template>

<script>
import mapLocator from "@/components/map/MapLocator"
export default {
  name: "locator",
  components: {mapLocator},
  props: {},
  data() {
    return {
        param:{}
    }
  },
  mounted(){
    if(this.$route.query.type && this.$route.query.objid){
      this.param = {type:this.$route.query.type,objid:this.$route.query.objid}
    }else{
      this.$toast('查询参数不正确')
    }
  },
  methods:{

  },
  computed:{
      
  }
}
</script>

<style scoped>
.dhmap-wrapper{
  width:100%;
  height: 100%;
}
</style>